var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.timestamp)?_c('span',{staticClass:"build-timestamp"},[_vm._v(_vm._s(_vm._f("moment")(_vm.timestamp,'YYYY-MM-DD, dddd HH:mm')))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }